<template>
    <div>
        <v-simple-table>
            <template #default>
                <thead>
                    <tr>
                        <th>Criteria</th>
                        <th>Score</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="teamQualifier.configs.hasPreferentialScore">
                        <td>Preferential Score</td>
                        <td>{{ numeral(division.preferentialScore).format('0.000') }}</td>
                    </tr>

                    <tr>
                        <td>Minimum Score</td>
                        <td>{{ numeral(division.minimumScore).format('0.000') }}</td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
    </div>
</template>

<script>
import numeral from 'numeral';

export default {
    name: 'SelectionScoreTable',

    props: {
        teamQualifier: {
            type: Object,
            required: true,
        },

        resultCategory: {
            type: Object,
            required: true,
        },
    },

    data: () => ({}),

    computed: {
        division() {
            const divisions = this.teamQualifier.configs.divisions.filter(division => {
                if (division.minAge === 11 && division.maxAge === 12 && this.resultCategory.level !== 'YE 11-12') {
                    return false;
                }
                if (division.minAge === 13 && division.maxAge === 14 && this.resultCategory.level !== 'YE 13-14') {
                    return false;
                }
                if (division.minAge === 15 && division.maxAge === 16 && this.resultCategory.level !== 'JR') {
                    return false;
                }
                if (
                    division.minAge === 17 &&
                    division.maxAge === 21 &&
                    !['IE', 'SR'].includes(this.resultCategory.level)
                ) {
                    return false;
                }

                return (
                    division.event === this.resultCategory.event &&
                    division.gender.toUpperCase() === this.resultCategory.gender.toUpperCase()
                );
            });

            return divisions[0];
        },
    },

    methods: {
        numeral,
    },
};
</script>
